module.exports = __webpack_public_path__ + "static/media/googledrive_logo.8690794f.png";


//////////////////
// WEBPACK FOOTER
// ./src/settings/Containers/gdUnitControlPanel/modules/main/googledrive_logo.png
// module id = 435
// module chunks = 0 1